import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, FormButtons, Notification } from '@portal/kit/pkg/components'

import SelectedOffer from 'components/offers/offer-detail/selected-offer'

export default function PaymentFailed({ offer, error, retry, order }) {
  const { t, i18n } = useTranslation()

  if (!i18n.exists(error)) {
    error = t("portal.offers.payment_failed.errors.default", { status_code: order.payment_error.code })
  }

  return (
    <Fragment>
      {offer && <SelectedOffer offer={offer} />}
      <Notification status="fail" message={error}></Notification>
      <FormButtons>
        <Button classType="cancel" to="/offers">{t('portal.offers.back_offers')}</Button>
        {offer && <Button onClick={retry}>{t('portal.offers.retry')}</Button>}
      </FormButtons>
    </Fragment>
  )
}
